import {createFileRoute, redirect} from "@tanstack/react-router";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {RouteComponent} from "./-routeComponent";

function redirectToNewChat(workspaceId: string): never {
    throw redirect({
        to: "/w/$workspaceId/adgpt/chats/$chatId",
        params: {workspaceId, chatId: "new"},
        replace: true,
    });
}

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_adgptScaffold/adgpt/chats/$chatId",
)({
    loader: async ({context, params}) => {
        const chatId = params.chatId === "new" ? null : params.chatId;

        // Treat malformed, missing, and unauthorized ids alike in the UI. Pluto remains the
        // authorization authority; redirect before the chat panel can issue transcript/detail
        // requests that would expose raw HTTP errors.
        if (chatId !== null) {
            if (!uuidZodValidator.safeParse(chatId).success) {
                redirectToNewChat(context.workspace.id);
            } else {
                const response = await fetch(`${context.intellsysBaseUrl}/sub-system/pluto/adgpt2/materialized/threads/read`, {
                    body: JSON.stringify({threadId: chatId}),
                    cache: "no-store",
                    headers: {
                        Authorization: `Bearer ${context.authenticationStatus.accessToken}`,
                        "Content-Type": "application/json",
                    },
                    method: "POST",
                    signal: AbortSignal.timeout(10_000),
                });
                if (response.status === 400 || response.status === 403 || response.status === 404) {
                    redirectToNewChat(context.workspace.id);
                } else if (!response.ok && response.status < 500) {
                    throw new Error(`Could not verify chat access (HTTP ${response.status}).`);
                }
                // A runtime 5xx must not replace the chat with the route error page. The chat
                // panel loads the transcript independently, so it may still recover the messages
                // and will present any remaining API failure as an inline error.
            }
        }

        return {
            chatId,
            workspaceId: context.workspace.id,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
});
